import { RouteInfo } from './sidebar.metadata';
export function getAlldata4() {
const spROUTES: RouteInfo[] = [


    {
        path: '', title: 'Supplier', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
             path: '/Vendor/Supplier/Dashboard/SD-dashboad-hospital', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            },
            {
             path: '/Vendor/Supplier/UploadInvoice/uploadInvoice', title: 'Upload Invoice', icon: 'fa fa-upload', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            },
            {
                path: '/Vendor/Supplier/Invoices/invoices', title: 'Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            },
            {
                path: '/Vendor/Supplier/Associate_Hospital/Hospital_List', title: 'Limits', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
            },

          {
            path: '/Vendor/Supplier/Editprofile/sdEditprofileHospital', title: 'Edit Profile', icon: 'fa fa-pencil-square-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
           },

        ]
    },

];

return spROUTES
}